import PortalAppService from "../../../application/platform/portal-app-service";
import { useCustomPageDispatch } from "./custom-page-context";
import { ACTION_TYPES } from "./custom-page-reducer";

export const useCustomPageController = () => {
    const dispatch = useCustomPageDispatch();

    const loadArticle = async (id: number) => {
        try {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: true });
            const article = await PortalAppService.getArticle(id);
            dispatch({ type: ACTION_TYPES.SET_ARTICLE, payload: article });
        } catch (error: any) {
            console.error('Error loading article:', error);
            dispatch({ type: ACTION_TYPES.SET_ERROR, payload: error?.message || 'Erro ao carregar artigo' });
        }
    };

    const loadCustomPage = async (slug: string) => {
        try {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: true });
            const page = await PortalAppService.getCustomPage(slug);
            dispatch({ type: ACTION_TYPES.SET_PAGE, payload: page });
        } catch (error: any) {
            // Página despublicada, excluída ou slug alterado: a API responde 404
            if (error?.response?.status === 404) {
                dispatch({ type: ACTION_TYPES.SET_NOT_FOUND });
                return;
            }
            console.error('Error loading custom page:', error);
            dispatch({ type: ACTION_TYPES.SET_ERROR, payload: error?.message || 'Erro ao carregar página' });
        }
    };

    return { loadArticle, loadCustomPage };
};
